import React from "react";
import { Menu, MenuItem } from "@blueprintjs/core";
import classNames from "classnames";
import Tag from "../../Tag";
import ScrollBar from "../../ScrollBar";
import TextTruncate from "../../TextTruncate";
import { highlightMatchingText } from "utils/string";
import { isNotEmpty } from "utils/validate";
import * as styles from "./styles.module.scss";
export const TAG_MAX_SYMBOLS_COUNT = 64;
export const getCreateNewItemRenderer = (selectedTags, tagsList, forbiddenTagsNames) => 
// eslint-disable-next-line react/display-name
(query, active, handleClick) => {
    const alreadyAdded = [...selectedTags, ...tagsList].some((tag) => tag.label === query.trim());
    const isForbidden = forbiddenTagsNames.includes(query);
    if (alreadyAdded || isForbidden || !query) {
        return undefined;
    }
    return (React.createElement(MenuItem, { className: styles["create-new"], text: React.createElement(React.Fragment, null,
            "Create tag:",
            React.createElement(Tag, { name: query })), active: active, onClick: handleClick, shouldDismissPopover: false }));
};
export const defaultItemRender = ({ label, disabled, className, isGroupName, groupId, value, shouldHighlight = true }, { handleClick, modifiers, query, index }, isAutoSuggest) => {
    if (!modifiers.matchesPredicate && !isGroupName) {
        return null;
    }
    const text = isAutoSuggest ? (React.createElement(TextTruncate, { className: classNames(styles.selectItem, { [styles.active]: modifiers.active && !isGroupName }, className), text: isGroupName || !shouldHighlight ? label : highlightMatchingText(label, query) })) : (React.createElement(Tag, { className: classNames(styles.tag, { [styles.active]: modifiers.active }, className), name: highlightMatchingText(label, query) }));
    return (React.createElement(MenuItem, { active: modifiers.active, disabled: modifiers.disabled || disabled || isGroupName, key: `${index}-${typeof value === "string" ? value : label}`, onClick: handleClick, shouldDismissPopover: false, className: styles.tagMenuItem, text: text, ...(isGroupName && { ["is-group-name"]: "true" }), ...(groupId && { ["group-id"]: groupId }) }));
};
export const defaultItemPredicate = (query, item, _index, exactMatch) => {
    const normalizedTitle = item.label.toLowerCase();
    const normalizedQuery = query.toLowerCase();
    if (exactMatch) {
        return normalizedTitle === normalizedQuery;
    }
    else {
        return normalizedTitle.indexOf(normalizedQuery) >= 0;
    }
};
export const defaultNoResultsRenderer = (React.createElement(MenuItem, { className: styles.emptyList, disabled: true, text: "No results found." }));
export const defaultListRenderer = (renderer, popoverRef, disableCreateNew, renderAdditionalListItem, noResultsRenderer, itemListPredicate, listProps) => {
    const { items, itemsParentRef, renderItem, renderCreateItem, query, filteredItems } = renderer;
    const renderedItems = itemListPredicate ? filteredItems.map(renderItem) : items.map(renderItem);
    const groupItemsIds = renderedItems
        .map((item) => {
        const props = item?.props;
        return props?.["is-group-name"] ? null : props?.["group-id"];
    })
        .filter((id) => id !== null);
    const filteredRenderedItems = renderedItems.filter((item) => {
        const props = item?.props;
        if (props?.["is-group-name"] && !groupItemsIds.includes(props?.["group-id"])) {
            return false;
        }
        return item != null;
    });
    if (popoverRef) {
        if (!filteredRenderedItems.length && query && !isNotEmpty(noResultsRenderer, true)) {
            popoverRef.classList.add(styles.emptyPopoverContent);
        }
        else {
            popoverRef.classList.remove(styles.emptyPopoverContent);
        }
    }
    let itemsToRender;
    if (filteredRenderedItems.length > 0) {
        itemsToRender = filteredRenderedItems;
    }
    else if (!query) {
        itemsToRender = isNotEmpty(noResultsRenderer, true) ? noResultsRenderer : defaultNoResultsRenderer;
    }
    else {
        itemsToRender = isNotEmpty(noResultsRenderer, true) ? noResultsRenderer : undefined;
    }
    return (React.createElement(ScrollBar, { autoHeight: true, autoHeightMax: listProps?.maxHeight ?? 300, className: styles.scrollBar },
        React.createElement(Menu, { ulRef: itemsParentRef },
            itemsToRender,
            renderAdditionalListItem && renderAdditionalListItem(renderer),
            !disableCreateNew && renderCreateItem())));
};
export const defaultCreateItem = (query) => ({
    value: query,
    label: query,
});
export const renderDefaultTag = (item) => item.label;
